export const PROMPT_SUGGESTIONS = [
  'Draft email replies to my important messages',
  'What time do I need to leave for that meeting tomorrow?',
  'For my meeting at 12p, get me some background on Jamie',
  'Summarize the emails I missed this weekend',
  'Create a packing list for my trip to Tokyo next week',
  'What did I talk about with Sarah last time we met?',
  'Build me a webpage for my portfolio and share the link',
  'Who have I been emailing the most this month?',
  'Remind me to follow up with David on Friday',
  "What's on my calendar this week that I can cancel?",
  'Find the best coffee shop near my 3pm meeting',
  "Add a task to research vendors before Monday's standup",
  'Give me a daily briefing every morning at 8am',
  'Search the web for reviews on the new Pixel phone',
  'Make a research report on competitors in my space',
  'Save this contact — I just met Alex at the conference',
  'What do I have going on this weekend?',
  'Help me plan a team dinner near the office for Thursday',
];

// Fast-path for initial conversational onboarding.
// We removed the artificial 5s+ theatrical delays so new users get to the
// chat (and the instant "What's your name?" greeting) as quickly as possible
// while still waiting for real backend readiness (modules exist).
export const POLL_INTERVAL_MS = 800;
/** At 45s we show a non-fatal "still warming up" banner. Polling continues.
 *  Previously this was the hard timeout — users hit the error screen on
 *  every fresh signup because workspace bootstrap on a cold postgres takes
 *  longer than 45s. */
export const SLOW_SETUP_MS = 45_000;
/** Hard ceiling. At 180s we surface the actual error UI + Report-issue
 *  button. Reached only when bootstrap is genuinely broken (closed pool,
 *  schema corruption, postgres outage). */
export const HARD_TIMEOUT_MS = 180_000;
export const MIN_VISIBLE_MS = 250;       // tiny grace to avoid flash; no long forced wait
export const STEP_1_DONE_AT_MS = 0;
export const STEP_2_DONE_AT_MS = 0;
export const FADE_OUT_DELAY_MS = 300;
export const PROMPT_ROTATE_MS = 2500;    // still cycles if the user has to wait
export const PROMPT_FADE_MS = 200;
